import { FC } from 'react';
import { ESize, ETextColor } from 'src/styles/theme/utils/enums';
import { EIcon } from './NGIcon.enum';
import { StyledIcon } from './NGIcon.styles';
import { INGIcon } from './NGIcon.type';

const NGIcon: FC<INGIcon> = ({
	type = EIcon.none,
	size = ESize.l,
	color = ETextColor.white,
	gradientColor,
	shadowColor,
	disabled = false,
	framesAuto = false,
	display,
	...otherProps
}) => (
	<StyledIcon
		size={size}
		textColor={color}
		gradientColor={gradientColor}
		shadowColor={shadowColor}
		disabled={disabled}
		framesAuto={framesAuto}
		display={display}
		{...otherProps}
	>
		<i className={`icon-${type}`} />
	</StyledIcon>
);

export { NGIcon };
